'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirect = redirect;
function redirect(url) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var form = document.createElement('form');
  form.method = 'POST';
  form.action = url;

  Object.keys(parameters).forEach(function (key) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = parameters[key];
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}